import { useCallback } from 'react';
import MunicipalPortalAAppService from 'application/platform/municipal-portal-service';
import { useNewsDetailsDispatch } from './news-details-context';
import { ACTION_TYPES } from './news-details-reducer';

export const useNewsDetailsController = () => {
  const dispatch = useNewsDetailsDispatch();

  const loadNewsDetails = useCallback(async (id: number) => {
    try {
      dispatch({ type: ACTION_TYPES.setLoading, payload: true });
      dispatch({ type: ACTION_TYPES.setError, payload: null });
      
      const response = await MunicipalPortalAAppService.getNews(id);
      
      dispatch({ type: ACTION_TYPES.setNewsDetails, payload: response });
    } catch (error) {
      console.error('Error loading news details:', error);
      dispatch({ type: ACTION_TYPES.setError, payload: 'Erro ao carregar detalhes da notícia' });
      dispatch({ type: ACTION_TYPES.setNewsDetails, payload: null });
    } finally {
      dispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }
  }, [dispatch]);

  const clearNewsDetails = useCallback(() => {
    dispatch({ type: ACTION_TYPES.setNewsDetails, payload: null });
    dispatch({ type: ACTION_TYPES.setError, payload: null });
  }, [dispatch]);

  return {
    loadNewsDetails,
    clearNewsDetails,
  };
};